var scope_0 = require('/Users/xc/dev/digimaker-ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/161dcb9fec21930a58ed69b1096d1e69.js').default;

var scope_1 = require('/Users/xc/dev/digimaker-ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/234890cd27ae5f09ff3e2c749d259471.js').default;

var scope_2 = require('/Users/xc/dev/digimaker-ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/586a4088f218c753af7217c38aea5516.js').default;

var scope_3 = require('/Users/xc/dev/digimaker-ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7083607609dc3bf30dedb7e731a5618f.js').default;

var scope_4 = require('/Users/xc/dev/digimaker-ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/73716a8f63f71947fd5510df057ddb92.js').default;

var scope_5 = require('/Users/xc/dev/digimaker-ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8ca865c7ddc134b0ef5f1c59d9324232.js').default;

var scope_6 = require('/Users/xc/dev/digimaker-ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9d92134069ea8fbcbf7a30124f41f19d.js').default;

var scope_7 = require('/Users/xc/dev/digimaker-ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a5669ccb4909d51fbd2b076b04fa53f8.js').default;

var scope_8 = require('/Users/xc/dev/digimaker-ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a844ee9f594ad4db42b0cd9e20fac6d5.js').default;

var scope_9 = require('/Users/xc/dev/digimaker-ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/aacff5c19d412f1e405516e8f9a1dcc2.js').default;

var scope_10 = require('/Users/xc/dev/digimaker-ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bd3216ad46b326e506145bf53e4f8ebe.js').default;

var scope_11 = require('/Users/xc/dev/digimaker-ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d36a560401f4b0e34557b7256e27b89a.js').default;

var scope_12 = require('/Users/xc/dev/digimaker-ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dac85f48a3f1839996f2de4e1d29fa1c.js').default;

var scope_13 = require('/Users/xc/dev/digimaker-ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var scope_14 = require('/Users/xc/dev/digimaker-ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/edfc3e7116af29fb539f3b2e77a89247.js').default;

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13, scope_14);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !Object.prototype.hasOwnProperty.call(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !Object.prototype.hasOwnProperty.call(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}